import { IconBase } from './IconBase'

type IconCommentProps = React.ComponentProps<'svg'>

export const IconComment = (props: IconCommentProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <path
        d="m5.789 17.894-.012-.242-.197-.141C3.434 15.974 2.1 13.707 2.1 11.2c0-4.509 4.35-8.3 9.9-8.3 5.55 0 9.9 3.791 9.9 8.3s-4.35 8.3-9.9 8.3c-.746 0-1.472-.07-2.17-.202a2.048 2.048 0 0 0-1.804.566c-1.005.98-2.385 1.869-3.975 2.014 1.64-.988 1.793-2.809 1.738-3.984Z"
        stroke="#fff"
      />
    </IconBase>
  )
}
